import { render, staticRenderFns } from "./fileimport.vue?vue&type=template&id=2dba4982&"
import script from "./fileimport.vue?vue&type=script&lang=js&"
export * from "./fileimport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports